import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/Home.vue'
import VueAnalytics from 'vue-analytics'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-17754788-3',
  beforeFirstHit () {
    Vue.$ga.set('anonymizeIp', true)
  },
  router
})

export default router
